export const hostNameByHardwareModel = (model: string) => {
  switch (model) {
    case 'Macmini6,1':
      return ['Pro Host', '']
    case 'Macmini7,1':
      return ['Pro Host', 'SVR-5000S-00']
    case 'Macmini8,1':
      return ['Pro Host', 'SVR-5100S']
    case 'Macmini9,1':
      return ['Pro Host', 'SVR-5200S']
    case 'MacPro6,1':
      return ['Super Pro Host', 'SVR-7000S']
    case 'MacPro7,1':
      return ['Super Pro Host', 'SVR-7100S']
    default:
      return ['Pro Host', '']
  }
}

export const hostNameByEnum: string[] = [
  '', // 0 // RPMUTILS_HOSTTYPE_MAC=0
  'Linux Smart Host (Legacy)', // 1 // RPMUTILS_HOSTTYPE_SMARTHOST_DEEPCANYON
  'Linux Smart Host (Legacy)', // 2 // RPMUTILS_HOSTTYPE_SMARTHOST_THINCANYON
  'Smart Host with Control', // 3 // RPMUTILS_HOSTTYPE_SMARTHOST_ACE
  '', // 4 // RPMUTILS_HOSTTYPE_SIMPLEHOST
  '', // 5 // RPMUTILS_HOSTTYPE_SIMPLEHOSTPRO
  'S2 Host', // 6 // RPMUTILS_HOSTTYPE_S2HOST
  '', // 7 // RPMUTILS_HOSTTYPE_MAC_SUPER
  'IP Audio Stereo Soundbar', // 8 // RPMUTILS_HOSTTYPE_CLAPTON_HOST
  'IP Audio 1', // 9 // RPMUTILS_HOSTTYPE_ASTLEY_HOST
  '', // 10 // RPMUTILS_HOSTTYPE_GWHOSTPRO
  '', // 11 // RPMUTILS_HOSTTYPE_TSTATHOSTPRO,
  'Smart Audio WISA Soundbar', // 12 // RPMUTILS_HOSTTYPE_MARLEY_HOST
  'S2 Host', // 13 // RPMUTILS_HOSTTYPE_S2SM_HOST
  'Smart Host with Control', // 14 // RPMUTILS_HOSTTYPE_SHR2000_HOST
  'Power Director', // 15 // RPMUTILS_HOSTTYPE_DIRECTOR
  'Power Director Lite', // 16 // RPMUTILS_HOSTTYPE_DIRECTOR_LITE
  'Power Director Plus', // 17 // RPMUTILS_HOSTTYPE_DIRECTOR_PLUS
  'Power Director Cellular', // 18 // RPMUTILS_HOSTTYPE_DIRECTORC
  'Power Director Lite Cellular', // 19 // RPMUTILS_HOSTTYPE_DIRECTOR_LITEC
  'Unknown', // 20 // RPMUTILS_HOSTTYPE_UNKNOWN
  'Unsupported Host', // 21 RPMUTILS_HOSTTYPE_STUDIO_UNSUPPORTED, Unsupported Mac Studio M1 variants
  'Pro Host', // 22 RPMUTILS_HOSTTYPE_MAC_EVO, EVO Supported Mac Mini (M2+) (instead of RPMUTILS_HOSTTYPE_MAC)
  'Pro Host', // 23 RPMUTILS_HOSTTYPE_MACMINIPRO_EVO, EVO Supported Mac Mini Pro (M2 Pro+) (instead of RPMUTILS_HOSTTYPE_MAC)
  'Super Pro Host', // 24 RPMUTILS_HOSTTYPE_MAC_SUPER_EVO, EVO Supported Mac Super Pro (M2+) (instead of RPMUTILS_HOSTTYPE_MAC_SUPER)
  'Studio Host', // 25 RPMUTILS_HOSTTYPE_STUDIOMAXM2, Mac Studio M2 Max
  'Studio Host', // 26 RPMUTILS_HOSTTYPE_STUDIOULTRAM2, Mac Studio M2 Ultra
  'Smart Audio WISA Soundbar', // 27 RPMUTILS_HOSTTYPE_MARLEY_ECO, EVO Supported HST-STUDIO55WS-SUR
  'IP Audio 1', // 28 RPMUTILS_HOSTTYPE_ASTLEY_ECO, EVO Supported HST-SIPA1ECO-00
  '', // 29 RPMUTILS_HOSTTYPE_DIRECTOR_PLUSC, HST-DIR DirectorPlusC
  'Keypad Host', // 30 Keypad Host
  'Linux Director 01', // 31 LINUX-DIRECTOR-1
  'Linux Director Cellular 01', // 32 LINUX-DIRECTORC-1
  'Smart Soundbar 55 with ARC', // 33 Smart Audio WISA Soundbar
  'Smart Soundbar 55 with ARC', // 34 Smart Audio WISA Soundbar
  'Keypad Host', // 35 Sage Keypad Host
  'Pro Host', // 36 RPMUTILS_HOSTTYPE_MAC_MINI_M4_EVO, EVO Supported Mac Mini Pro 
  'Keypad Host', // 37 Sage Keypad Host
  'Studio Host', // 38 RPMUTILS_HOSTTYPE_STUDIOULTRAM3
  'Studio Host', // 39 RPMUTILS_HOSTTYPE_STUDIOMAXM4
  'Desktop Host', // 40 RPMUTILS_HOSTTYPE_DESKTOP
  'Director Sage Surface Mount', // 41 RPMUTILS_HOSTTYPE_DIRECTOR_SAGE_SM
  'Director PSXX Inverter', // 42 RPMUTILS_HOSTTYPE_PS20
]

export const hostNameSecondaryByEnum: string[] = [
  '', // 0 // RPMUTILS_HOSTTYPE_MAC=0
  'HST-SMRTD-00', // 1 // RPMUTILS_HOSTTYPE_SMARTHOST_DEEPCANYON
  'HST-SMRTD-10', // 2 // RPMUTILS_HOSTTYPE_SMARTHOST_THINCANYON
  'SHC-2000', // 3 // RPMUTILS_HOSTTYPE_SMARTHOST_ACE
  '', // 4 // RPMUTILS_HOSTTYPE_SIMPLEHOST
  '', // 5 // RPMUTILS_HOSTTYPE_SIMPLEHOSTPRO
  'SHC-S2', // 6 // RPMUTILS_HOSTTYPE_S2HOST
  '', // 7 // RPMUTILS_HOSTTYPE_MAC_SUPER
  'HST-STUDIOXX-2CH', // 8 // RPMUTILS_HOSTTYPE_CLAPTON_HOST
  'HST-SIPA1SM', // 9 // RPMUTILS_HOSTTYPE_ASTLEY_HOST
  '', // 10 // RPMUTILS_HOSTTYPE_GWHOSTPRO
  '', // 11 // RPMUTILS_HOSTTYPE_TSTATHOSTPRO,
  'HST-STUDIOXX-SUR', // 12 // RPMUTILS_HOSTTYPE_MARLEY_HOST
  'SHR-S2', // 13 // RPMUTILS_HOSTTYPE_S2SM_HOST
  'SHR-2000', // 14 // RPMUTILS_HOSTTYPE_SHR2000_HOST
  'HST-DIRECTOR', // 15 // RPMUTILS_HOSTTYPE_DIRECTOR
  'HST-DIRECTORLITE', // 16 // RPMUTILS_HOSTTYPE_DIRECTOR_LITE
  'HST-DIRECTORPLUS', // 17 // RPMUTILS_HOSTTYPE_DIRECTOR_PLUS
  'HST-DIRECTOR-C', // 18 // RPMUTILS_HOSTTYPE_DIRECTORC
  'HST-DIRECTORLITE-C', // 19 // RPMUTILS_HOSTTYPE_DIRECTOR_LITEC
  'Unknown', // 20 // RPMUTILS_HOSTTYPE_UNKNOWN
  'Unsupported', // 21 RPMUTILS_HOSTTYPE_STUDIO_UNSUPPORTED, Unsupported Mac Studio M1 variants
  'SVR-5300S', // 22 RPMUTILS_HOSTTYPE_MAC_EVO, EVO Supported Mac Mini (M2+) (instead of RPMUTILS_HOSTTYPE_MAC)
  'SVR-5300S', // 23 RPMUTILS_HOSTTYPE_MACMINIPRO_EVO, EVO Supported Mac Mini Pro (M2 Pro+) (instead of RPMUTILS_HOSTTYPE_MAC)
  'SVR-7300S', // 24 RPMUTILS_HOSTTYPE_MAC_SUPER_EVO, EVO Supported Mac Super Pro (M2+) (instead of RPMUTILS_HOSTTYPE_MAC_SUPER)
  'SVR-6300S', // 25 RPMUTILS_HOSTTYPE_STUDIOMAXM2, Mac Studio M2 Max
  'SVR-6800S', // 26 RPMUTILS_HOSTTYPE_STUDIOULTRAM2, Mac Studio M2 Ultra
  'HST-STUDIOXX-ECO', // 27 RPMUTILS_HOSTTYPE_MARLEY_ECO, EVO Supported HST-STUDIO55WS-SUR
  'HST-SIPA1ECO', // 28 RPMUTILS_HOSTTYPE_ASTLEY_ECO, EVO Supported HST-SIPA1ECO-00
  '', // 29 RPMUTILS_HOSTTYPE_DIRECTOR_PLUSC, HST-DIR DirectorPlusC
  'HST-KEYPAD-00', // 30 KEYPAD HOST 00 
  'LINUX-DIRECTOR-1', // 31 LINUX-DIRECTOR-1
  'LINUX-DIRECTORC-1', // 32 LINUX-DIRECTORC-1
  'HST-STUDIO55ARC-SUR', // 33 HST-STUDIO55WSARC
  'HST-STUDIO55ARC-ECO', // 34 HST-STUDIO55WSARC-ECO
  'HST-SAGEMF-00', // 35 SAGE KEYPAD HOST
  'SVR-5400S', // 36 RPMUTILS_HOSTTYPE_MAC_MINI_M4_EVO, EVO Supported Mac Mini 
  'HST-SAGEMF-00', // 37 SAGE KEYPAD HOST
  'SVR-6400S', // 38 RPMUTILS_HOSTTYPE_STUDIOULTRAM3
  'SVR-6900S', // 39 RPMUTILS_HOSTTYPE_STUDIOMAXM4
  'HST-DESKTOP-00', // 40 RPMUTILS_HOSTTYPE_DESKTOP
  'HST-SAGE-SM-00', // 41 RPMUTILS_HOSTTYPE_DIRECTOR_SAGE_SM
  'PS-INV-12.5KW-GEN2-00MSA', // 42 RPMUTILS_HOSTTYPE_PS20
]
